import { Actionsheet, Box, useMediaQuery } from "native-base";
import React, { useEffect, useState } from "react";
import { Dimensions, Image } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import PDFReader from "rn-pdf-reader-js";
import {
	ComponentButton,
	ComponentButtonGroup,
	ComponentCenter,
	ComponentFlatList,
	ComponentForm,
	ComponentHeading,
	ComponentHStack,
	ComponentInput,
	ComponentMenu,
	ComponentMenuGroup,
	ComponentStack,
	ComponentText,
	ComponentView,
	ComponentVStack,
} from "../../components/dynamic/ComponentsGenerator";
import ErrorToast from "../../components/ErrorToast";
import Loader from "../../components/Loader";
import {
	getAttachment,
	getHistory,
	resetAttachment,
} from "../../redux/slices/HistorySlice";

const initialLayout = { width: Dimensions.get("window").width };
const KeysToComponentMap = {
	// card: (props) => ComponentCard({setHistory: (parameter) => setHistory(parameter), ...props}),
	// button: (props) => ComponentButton({setHistory: (parameter) => setHistory(parameter), ...props}),
	VIEW: (props) =>
		ComponentView({
			...props,
		}),
	TABLE: (props) =>
		ComponentFlatList({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {history: history, tableData: data, keyField: 'id', 'desktop': isDesktopOrLaptop}
		}),
	BUTTON: (props) =>
		ComponentButton({
			// onSubmit: () => onSubmit(), onCancel: () => onCancel(),
			...props,
			//extraProps: {'desktop': isDesktopOrLaptop}
		}),
	BUTTON_GROUP: (props) =>
		ComponentButtonGroup({
			// setHistory: (parameter) => setHistory(parameter),
			...props,
			//extraProps: {'desktop': isDesktopOrLaptop}
		}),
	INPUT: (props) =>
		ComponentInput({
			...props,
			//setCurrentInput: (parameter) => setDates(parameter),
			// onChange: (key, value) => onChange(key, value), params: params,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	FORM: (props) =>
		ComponentForm({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	CONTENT: (props) =>
		ComponentView({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	HEADING: (props) =>
		ComponentHeading({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	MENU_GROUP: (props) =>
		ComponentMenuGroup({
			// setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	TEXT: (props) =>
		ComponentText({
			// setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	HSTACK: (props) =>
		ComponentHStack({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			//extraProps: {'desktop': isDesktopOrLaptop}
		}),
	VSTACK: (props) =>
		ComponentVStack({
			// setHistory: (parameter) => setHistory(parameter),
			...props,
			//extraProps: {'desktop': isDesktopOrLaptop}
		}),
	STACK: (props) =>
		ComponentStack({
			// setHistory: (parameter) => setHistory(parameter),
			...props,
			// extraProps: {'desktop': isDesktopOrLaptop}
		}),
	CENTER: (props) =>
		ComponentCenter({
			//setHistory: (parameter) => setHistory(parameter),
			...props,
			//extraProps: {'desktop': isDesktopOrLaptop}
		}),
	MENU: (props) =>
		ComponentMenu({
			...props,
		}),
};
const renderer = (component, isDesktopOrLaptop, hooks) => {
	if (typeof KeysToComponentMap[component.componenttype_name] !== "undefined") {
		return React.createElement(
			KeysToComponentMap[component.componenttype_name],
			{
				...component,
				desktop: isDesktopOrLaptop,
				hooks: hooks,
				key: component.sitepagecomponent_guid,
			},
			component.children_components &&
				(component.children_components === []
					? component.componenttype_name === "TEXT" ||
					  component.componenttype_name === "BUTTON"
						? component.sitepagecomponent_meta.name
						: null
					: component.children_components.map((child) =>
							renderer(child, isDesktopOrLaptop, hooks)
					  ))
		);
	}
};

const MyHistory = ({ navigation }) => {
	const { width, height } = Dimensions.get("window");
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 })[0];
	const components = useSelector((state) => state.Page.Pages);
	// console.log("COMP", components);
	const [params, setParams] = useState({ page: 1, per_page: 10 });
	const [filter, setFilter] = useState(false);
	const [openImage, setOpenImage] = useState(false);
	const [history, setHistory] = useState("Claims");
	const [attachment, setAttachment] = useState("");
	const [getAttachments, setGetAttachments] = useState(false);
	const [claim, setClaim] = useState([]);
	const [offset, setOffset] = useState(1);
	const [loading, setLoading] = useState(true);
	const [dataSource, setDataSource] = useState([]);
	const [tableData, setTableData] = useState([]);
	const [tablePager, setTablePager] = useState({ pages: 0, records: 0 });
	const dispatch = useDispatch();
	const Histories = useSelector((state) => state.History.Histories);
	const Attachment = useSelector((state) => state.History.Attachment);
	const AttachmentLoading = useSelector((state) => state.History.loading);
	const Loading = useSelector((state) => state.History.loading);
	const claimsHistory = Histories?.Claims?.data;
	const pages = Histories?.Claims?.pages;
	const record = Histories?.Claims?.records;
	const transPages = Histories?.Transactions?.pages;
	const transRecord = Histories?.Transactions?.records;
	const transactionsHistory = Histories?.Transactions?.data;
	const slug = useSelector((state) => state.Page.Slug);
	useEffect(() => {
		setParams({ page: 1, per_page: 10 });
		setTableData([]);
		setOffset(1);
		setHistory("");
	}, [slug]);

	useEffect(() => {
		if (Histories?.Claims?.pages && history === "Claims") {
			setTablePager({
				pages: Histories?.Claims?.pages[0],
				records: Histories?.Claims?.records[0],
			});
		}
		if (Histories?.Transactions?.pages && history === "Transactions") {
			setTablePager({
				pages: Histories?.Transactions?.pages[0],
				records: Histories?.Transactions?.records[0],
			});
		}
		// console.log(tablePager);
	}, [pages, transPages]);

	useEffect(() => {
		// console.log('PARAMS CHANGED', params);
	}, [params]);

	// const downloadAttachment = () => {
	// 	// console.log('Get attachment', claim);
	// 	try {
	// 		dispatch(getAttachment(claim.claims_attachments[0].guid)).then((data) => {
	// 			setGetAttachments(false);
	// 		});
	// 	} catch (error) {
	// 		console.log(error);
	// 	}
	// };

	const getData = (page, type) => {
		setTableData([]);
		if (type !== undefined) {
			setHistory(type);
		}
		setOffset(page);
		// console.log('getData', page);
		let currentParams = params;
		currentParams["page"] = page;
		setParams(currentParams);
		dispatch(
			getHistory({
				history: type,
				params: params,
			})
		)
			.then((response) => {
				// console.log('Response 206', response.payload);
				const { result, data, pages, records } = response.payload;
				if (result) {
					setTableData(data[0]);
				}
			})
			.catch((error) => {
				console.log("Error 213", error);
				ErrorToast("Error getting history");
			});
	};

	const viewAttachment = (claim) => {
		try {
			dispatch(getAttachment(claim.claims_attachments[0].guid));
		} catch (error) {
			console.log(error);
		}
	};

	useEffect(() => {
		if (!Attachment) return;

		setGetAttachments(false);
		setAttachment(Attachment);
		if (isDesktopOrLaptop) {
			let date = new Date().toISOString().substring(0, 10).split("-").join("");
			let time = new Date().toISOString().substring(11, 19).split(":").join("");
			let fileName = `ClaimAttachment_${date}_${time}`;
			setOpenImage(false);
			// window.open(`data:${Attachment?.mime_type};base64,${Attachment?.data_text}`);
			downloadFile(
				`data:${Attachment?.mime_type};base64,${Attachment?.data_text}`,
				fileName
			);
		} else {
			setOpenImage(true);
		}
	}, [AttachmentLoading]);

	const showMode = (currentMode) => {
		setShow(true);
		setMode(currentMode);
	};
	const onSubmit = () => {
		if (history === "") {
			ErrorToast("Select history type");
			return false;
		}
		dispatch(
			getHistory({
				history: history,
				params: params,
			})
		)
			.then((response) => {
				// console.log("Response 231", response.payload);
				const { result, data, pages, records } = response.payload;
				if (result) {
					setTableData(data[0]);
					setFilter(false);
				}
			})
			.catch((error) => {
				console.log("Error 213", error);
				ErrorToast("Error getting history");
			});
	};
	const onCancel = () => {
		let historyNow = history;
		setParams({});
		setHistory("");
		setHistory(historyNow);
	};
	const showDatepicker = () => {
		showMode("date");
	};
	const downloadFile = (base64String, fileName) => {
		const linkSource = base64String;
		const downloadLink = document.createElement("a");

		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();

		dispatch(resetAttachment(""));
	};

	const onChange = (name, value) => {
		setOffset(1);
		setParams({
			...params,
			[name]: value,
			page: 1,
		});
	};
	let hooks = {
		onSubmit: onSubmit,
		onChange: onChange,
		onCancel: onCancel,
		params: params,
		setParams: (param) => setParams(param),
		history: history,
		setHistory: (hist) => setHistory(hist),
		tableData: tableData,
		filter: filter,
		setFilter: (status) => setFilter(status),
		navigation: navigation,
		setAttachment: (image) => setAttachment(image),
		setOpenImage: (open) => setOpenImage(open),
		getData: (page, type) => getData(page, type),
		setViewAttachment: (claim) => {
			setClaim(claim);
			viewAttachment(claim);
		},
		offset: offset,
		setOffset: (page) => setOffset(page),
		tablePager: tablePager,
	};
	return (
		<>
			<Box bg="#fff" padding={isDesktopOrLaptop ? 20 : 2} borderRadius={5}>
				{components.map((component) =>
					renderer(component, isDesktopOrLaptop, hooks)
				)}
			</Box>
			<Actionsheet
				isOpen={openImage}
				onClose={() => {
					dispatch(resetAttachment(""));
					setOpenImage(false);
				}}
			>
				<Actionsheet.Content
					size="md"
					style={{
						height: height / 1.3,
						alignSelf: "center",
						// backgroundColor: "transparent",
					}}
				>
					{!isDesktopOrLaptop &&
						attachment.mime_type !== undefined &&
						attachment?.mime_type.includes("pdf") && (
							<PDFReader
								style={{
									width: "100%",
									height: "100%",
								}}
								source={{
									base64: `data:${attachment.mime_type};base64,${attachment.data_text}`,
								}}
							/>
						)}
					{attachment.mime_type !== undefined &&
						attachment?.mime_type.includes("image") && (
							<Image
								resizeMode="contain"
								source={{
									uri: `data:${attachment.mime_type};base64,${attachment.data_text}`,
								}}
								style={{
									width: height / 1.8,
									height: height / 1.2,

									resizeMode: "stretch",
								}}
							/>
						)}
				</Actionsheet.Content>
			</Actionsheet>
			<Loader loading={Loading} text="Loading data..." />
		</>
	);
};

export default MyHistory;
